// assumptions section
export const ASSUMPTIONS = 'assumptions'
export const DROP_OFF = 'drop_off'
export const DEAD_WEIGHT = 'deadweight'
export const ATTRIBUTION = 'attribution'
export const DISPLACEMENT = 'displacement'
export const ASSUMPTION_NAME = 'assumption_name'

const assumptionsNames = [
  'players_health_impact',
  'players_wellbeing_impact',
  'players_non_financial_human_impact',
  'players_non_financial_health_impact',
  'community_players_health_impact',
  'community_players_wellbeing_impact',
  'community_players_non_financial_human_impact',
  'community_players_non_financial_health_impact',
  'attendees_health_impact',
  'attendees_wellbeing_impact',
  'attendees_non_financial_human_impact',
  'attendees_non_financial_health_impact',
  'community_attendees_health_impact',
  'community_attendees_wellbeing_impact',
  'community_attendees_non_financial_human_impact',
  'community_attendees_non_financial_health_impact',
  'volunteers_health_impact',
  'volunteers_wellbeing_impact',
  'volunteers_non_financial_human_impact',
  'volunteers_non_financial_health_impact',
  'community_volunteers_health_impact',
  'community_volunteers_wellbeing_impact',
  'community_volunteers_non_financial_human_impact',
  'community_volunteers_non_financial_health_impact',
  'temporary_coaches_health_impact',
  'temporary_coaches_wellbeing_impact',
  'temporary_coaches_non_financial_human_impact',
  'temporary_coaches_non_financial_health_impact',
  'permanent_coaches_health_impact',
  'permanent_coaches_wellbeing_impact',
  'permanent_coaches_non_financial_human_impact',
  'permanent_coaches_non_financial_health_impact',
  'community_temporary_coaches_health_impact',
  'community_temporary_coaches_wellbeing_impact',
  'community_temporary_coaches_non_financial_human_impact',
  'community_temporary_coaches_non_financial_health_impact',
  'community_permanent_coaches_health_impact',
  'community_permanent_coaches_wellbeing_impact',
  'community_permanent_coaches_non_financial_human_impact',
  'community_permanent_coaches_non_financial_health_impact',
  'permanent_employees_health_impact',
  'permanent_employees_wellbeing_impact',
  'permanent_employees_non_financial_human_impact',
  'permanent_employees_non_financial_health_impact',
  'temporary_employees_health_impact',
  'temporary_employees_wellbeing_impact',
  'temporary_employees_non_financial_human_impact',
  'temporary_employees_non_financial_health_impact'
]

const formatAssumptionLabel = name => {
  return name.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
}

export const assumptionsOptions = assumptionsNames.map(name => ({
  value: name,
  label: formatAssumptionLabel(name)
}))
